
import Vue from 'vue'
import VueLazyload from 'vue-lazyload';
import Scroll from '@/components/sroll.vue';
import wx from 'weixin-js-sdk';
import axios from 'axios';
import XHeader from 'vux/src/components/x-header/index.vue'
import XTextarea from 'vux/src/components/x-textarea/index.vue'
import XImg from 'vux/src/components/x-img/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import Divider from 'vux/src/components/divider/index.vue'
import InlineLoading from 'vux/src/components/inline-loading/index.vue'
import Previewer from 'vux/src/components/previewer/index.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'
import dateFormat from 'vux/src/tools/date/format.js'

import {fetch,promptMessage,baseUrl} from '@/api/dataHandling.js';
import {urlConfig} from '@/api/urlConfig.js';
import {getken} from '@/api/getToken';
import '../../../../static/js/font';
import patImg from '../../integralMallProject/images/1.png';
import doctorImg from '../images/doctorImg.png';
import $ from 'jquery';
export default {

data(){
return {
messages:'',
headoption:{
showBack:false
},
loadingNum:0,
patientMsg:[],
doctorMsg:[],
chatList:[],
reloading:true,
firstdata:true,
footerShow:false,
doctorImg:doctorImg,
pageNum:1,
pageSize:15,
list: [],
options: {
getThumbBoundsFn (index) {
let thumbnail = document.querySelectorAll('.previewer-demo-img')[index]
let pageYScroll = window.pageYOffset || document.documentElement.scrollTop
let rect = thumbnail.getBoundingClientRect()
return {x: rect.left, y: rect.top + pageYScroll, w: rect.width}
}
}

}
},
directives: {
TransferDom
},
components: {
XHeader,XTextarea,XImg, XButton,Divider, Previewer,'v-scroll': Scroll,InlineLoading
},
methods: {
increment(){
var obj = document.getElementsByClassName('yo-scroll')[0];
if(obj.scrollHeight-obj.scrollTop-obj.clientHeight<200){  //自动刷到底部
this.loadingNum = 0;
}else {
this.loadingNum = 1;
}
/*  console.log(this.loadingNum)*/
},
childincrem(b){
this.reloading = b;
this.increment();

},
imgClose(){
this.reloading = true;
},//图片预览关闭时
onRefresh(done) {
this.pageNum++;
/* this.$store.commit('updateLoadingStatus', {isLoading: true});
this.bottomif = true;*/
this.getnews(1);
done() 

},
onInfinite(done) {  //到頁面底部
console.log(234324324234)
done()
},
messagesfous(){
document.getElementsByClassName('yo-scroll')[0].scrollTop = document.getElementsByClassName('yo-scroll')[0].scrollHeight;
},//获取焦点
closepage(){
WeixinJSBridge.call("closeWindow");
},//关闭页面
sendTxt(){

if(this.messages.replace(/(^\s*)|(\s*$)/g,"") == ''){
return false;
}
this.$store.commit('updateLoadingStatus',{isLoading:true});
this.txtparamsData = {};
this.txtparamsData.context = this.messages;
this.txtparamsData.contextType = 3;
this.txtparamsData.personInfoId = this.personId;
this.txtparamsData.status = 1;
this.txtparamsData.personType = this.personType;
this.txtparamsData.idWeAdvisoryOrderInfo = this.bizId;
fetch('post',urlConfig.onlineSendMsgurl,this.txtparamsData).then(response => {
if(response.id){
if(this.personType == 'p'){
response.img = this.headimgurl;

}else {
response.img = doctorImg;
}
response.object = 'mysay';
response.createdDate = dateFormat(new Date(), 'YYYY-MM-DD HH:mm:ss');
this.chatList.push(response);
this.messages = '';
$('textarea').css('height','25px');
this.scrollBottom();
this.$store.commit('updateLoadingStatus',{isLoading:false});
}
}).catch(error => {

})
},
imgUPdate(){
var _this = this;
axios.get('http://front.wh.jinxin-fertility.com/weixin/getsigninfo?url=' + encodeURIComponent(window.location.href)).then(response => {
_this.weixindata = response.data;
wx.config({
debug: false,
appId: _this.weixindata.appId,
timestamp: _this.weixindata.timestamp,
nonceStr: _this.weixindata.noncestr,
signature: _this.weixindata.signature,
jsApiList: ['checkJsApi','chooseImage','uploadImage']
});
}).catch(function (error) {
console.log('error: ' +error)

})
wx.ready(function(){
wx.checkJsApi({
jsApiList: ['chooseImage','uploadImage'], // 需要检测的JS接口列表，所有JS接口列表见附录2,
success: function(res) {
}
});
wx.chooseImage({
sizeType: ['compressed'], // 可以指定是原图还是压缩图，默认二者都有
sourceType: ['album', 'camera'], // 可以指定来源是相册还是相机，默认二者都有
success: function (res) {
var localIds = res.localIds; 
_this.uploadImage(res.localIds);
}
});

});
},
uploadImage(localIds){
var _this = this;
_this.$store.commit('updateLoadingStatus',{isLoading:true});
var localId = localIds.shift();
wx.uploadImage({
localId: localId,
isShowProgressTips: 1,
success: function (res) {
var serverId = res.serverId; 
var fromUpdate = new URLSearchParams();
fromUpdate.append('mediaId',serverId);
fromUpdate.append('filepath','ivf_we/'+ _this.personId);
fetch('post',urlConfig.getWXimgURL,fromUpdate).then(response => {
_this.txtparamsData = {};
_this.txtparamsData.contextType = 1;
_this.txtparamsData.personInfoId = _this.personId;
_this.txtparamsData.url = response.filename;
_this.txtparamsData.status = 1;
_this.txtparamsData.idWeAdvisoryOrderInfo = _this.bizId;
_this.txtparamsData.personType = _this.personType;
fetch('post',urlConfig.onlineSendMsgurl,_this.txtparamsData).then(response2 => {
if(response2.id){
if(_this.personType == 'p'){
response2.img = _this.headimgurl;

}else {
response2.img = doctorImg;
}
response2.object = 'mysay';
response2.createdDate = dateFormat(new Date(), 'YYYY-MM-DD HH:mm:ss');
response2.src = baseUrl + urlConfig.imgLook +'/'+ response.filename + '?token=' + window.localStorage.getItem('token');
_this.chatList.push(response2);
_this.$nextTick(() => {
_this.list.push({msrc:response2.src,src:response2.src})
_this.scrollBottom();
})

_this.$store.commit('updateLoadingStatus',{isLoading:false});
}
}).catch(error => {
});
}).catch(error => {
});


if (localIds.length > 0) {
_this.uploadImage(localIds);

}
}
});

},
show(src) {
for(let i =0;i<this.list.length;i++){
if(src == this.list[i].src){
this.$refs.previewer.show(i);
}
}
this.reloading = false;
}, //点击图片放大
messagesClick(event){
var _this = this;
setTimeout(function () {
_this.$refs.inputBox.scrollIntoView(true);
_this.$refs.inputBox.scrollIntoViewIfNeeded(true);
},100)
},
myTouchMove(evt) {
if(document.hasFocus){
$('.messagesClass').blur();  
document.activeElement.blur();   
}
},
isShowFooter(){
if(this.$route.query.isdoctor == 1){
if(this.$route.query.status == 1){
this.footerShow = true;
}
}else {
fetch('get',urlConfig.onlinepatientAuthorityurl + this.personId).then(response => {
if(response){
this.footerShow = true;
}
}).catch(error => {
})
}
}, //是否有权限发消息
getDataMethod(numread,dateif){
fetch('post',urlConfig.onlineGetMsgurl,this.paramsData).then(response => {
if(response.list.length == 0){
this.$store.commit('updateLoadingStatus',{isLoading:false});
return false;
}
for(let j =0;j<response.list.length;j++) {
if(response.list[j].url != null){
response.list[j].src = baseUrl + urlConfig.imgLook + '/' + response.list[j].url + '?token=' + window.localStorage.getItem('token');
if(numread ==1){  //如果是初始获取数据
this.list.unshift({msrc:response.list[j].src, src: response.list[j].src});
}else {//如果是刷新数据
this.list.push({msrc:response.list[j].src, src: response.list[j].src});
}

}
if(numread ==1){  //如果是初始获取数据
/*      this.totalPage = response.pages;
if(this.pageNum >=this.totalPage){
this.$el.querySelector('.pull-refresh').style.display = 'none';  
}else {
this.$el.querySelector('.pull-refresh').style.display = 'block';  
}*/
this.chatList.unshift(response.list[j]);
}else {//如果是刷新数据
this.chatList.push(response.list[j]);
}

}
for(let i =0;i<this.chatList.length;i++) {
if(this.$route.query.isdoctor == 1){  //如果是医生
if (this.chatList[i].personType == 'd') {
this.chatList[i].img = doctorImg;
this.chatList[i].object = 'mysay';
} else {
this.chatList[i].img = this.headimgurl;
this.chatList[i].object = 'othersay';
}
}else{//如果是患者
if (this.chatList[i].personType == 'p') {
this.chatList[i].object = 'mysay';
this.chatList[i].img = this.headimgurl;
} else {
this.chatList[i].object = 'othersay';
this.chatList[i].img = doctorImg;
}

}
}
if(this.firstdata && dateif== 0){
console.log(1)
this.scrollBottom();
}else {
if((this.loadingNum ==0) && this.numread != 1 ){
this.scrollBottom();
}
}

this.$store.commit('updateLoadingStatus',{isLoading:false});

}).catch(error => {

});
},
getnews(dateif){
if(this.$route.query.isdoctor == 1){
this.personType = 'd';
this.objType = 'p';
}else {
this.personType = 'p';
this.objType = 'd';
}
this.paramsData ={};
this.paramsData.bizId = this.bizId;
this.paramsData.orderBy = 1;
if(dateif ==1){  // 加载历史数据
this.paramsData.orderBy = 1;
this.paramsData.pageNum = this.pageNum;
this.paramsData.pageSize = this.pageSize;
this.paramsData.endTime = this.chatList[0].createdDate;
this.getDataMethod(1,dateif);
}else if(dateif ==2){ //定时刷新
this.paramsData.orderBy = 2;
this.paramsData.type = this.objType;
this.paramsData.pageNum = 1;
this.paramsData.pageSize = 15;
for(let i=0;i<this.chatList.length;i++){
if(this.chatList[i].personType == this.objType){
this.paramsData.startTime = this.chatList[i].createdDate;
}
}
this.getDataMethod(2,dateif);
}else {  // 如果是初始化加载
this.paramsData.orderBy = 1;
this.paramsData.pageNum = this.pageNum;
this.paramsData.pageSize = this.pageSize
fetch('post',urlConfig.getUserMsg+'?openId=' + this.openidMsg).then(res => { //获取头像
this.headimgurl = res.headimgurl;
this.getDataMethod(1,dateif);
}).catch(error => {
}) //获取头像
}

},  //获取聊天记录
getunreadData(){
if(this.reloading){
this.getnews(2)
}

},
scrollBottom(){
this.$nextTick(()=>{
var titletopH = parseInt($('.titletop').css('height'));
var footerH =parseInt($('.footer').css('height'));
$('.content').css('height',(this.windowsH-footerH-titletopH) +'px');
document.getElementsByClassName('yo-scroll')[0].scrollTop = document.getElementsByClassName('yo-scroll')[0].scrollHeight;
})
}, //滚到底部
},
mounted(){
this.mm =[];
this.windowsH = window.innerHeight;
var _this = this;
getken(this.isShowFooter);
this.$store.commit('updateLoadingStatus',{isLoading:true});
this.personId = this.$route.query.personId;
this.bizId =  this.$route.query.id;
if(this.$route.query.isdoctor == 1){  //如果是醫生
this.patientMsg = this.$route.query.title.split(',');
this.headoption.showBack = true;
fetch('post',urlConfig.getUserOpenid+'?personInfoId=' + this.$route.query.patientpersonId).then(res => {  //获取患者openid
this.openidMsg = res;
this.getnews();
}).catch(error => {

})
}else {
/*this.doctorMsg = this.$route.query.title.split(',');*/
this.doctorMsg = ['生殖专家','不孕症与辅助生殖、生殖内分泌。'];
this.openidMsg = this.$route.query.openid;
this.getnews();
}
this.scrollBottom();
window.onresize =function(){
_this.windowsH = window.innerHeight;
_this.scrollBottom();
}
setInterval(function(){
_this.firstdata = false;
_this.getunreadData();
},5000);  //5秒刷新一次
this.$Lazyload.$on('loaded', function ({ bindType, el, naturalHeight, naturalWidth, $parent, src, loading, error }, formCache) {
el.parentNode.children[0].style.display = 'none';
/*console.log(_this.pageNum,_this.loadingNum)*/
if(_this.firstdata){
if(_this.pageNum == 1) {
_this.scrollBottom();
}
}else {
if(_this.loadingNum == 0) {
_this.scrollBottom();
}
}


});
}

}



// WEBPACK FOOTER //
// ./src/project/onlineServicesProject/patient/patientChatWindow.vue